export default {
    eyebrow: 'Your first minute in Studio',
    title: 'Welcome to {company}.',
    description: 'Your team has a place to turn its knowledge into useful content. Here is a simple way to get started.',
    firstProject: 'Your team’s first content brief',
    teamGoal: 'What your team is working toward',
    noBrief: 'Start with one question you know how to answer. A short, useful recording is enough to get moving.',
    noRepeat: 'Use your company’s shared information in Studio. There is no company questionnaire to repeat.',
    continue: 'Choose my first step',
    chooseTitle: 'What would you like to do first?',
    chooseDescription: 'Pick what is useful to you today. You can explore the rest any time.',
    recordTitle: 'Make a first recording',
    recordDescription: 'Open Recording and choose a solo or team recording.',
    profileTitle: 'Make my profile useful',
    profileDescription: 'Add your expertise and a photo so teammates know who you are.',
    exploreTitle: 'Explore my channel',
    exploreDescription: 'See what your team is sharing and where you can contribute.',
    start: 'Let’s get started', saving: 'Saving…', later: 'Remind me tomorrow', skip: 'I’ll find my own way',
    error: 'We could not save your choice. Please try again.',
}
